export const CLINIC_MAP_EMBED_URL =
  'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7066.952156479838!2d85.318559!3d27.671677!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39eb19001b2b5daf%3A0x8925f470cf5a590!2sDynamic%20Dental%20-%20Dental%20Clinic%20in%20Lalitpur!5e0!3m2!1sen!2snp!4v1787754810056!5m2!1sen!2snp';

export const CLINIC_MAP_DIRECTIONS_URL = 'https://maps.app.goo.gl/rSATc5uWXSZB9uBP6';

export const CLINIC_DISPLAY_ADDRESS = 'Beside Yamaha Showroom, Kumaripati, Lalitpur, Nepal';

export const CLINIC_PHONE = '+977-984-0354608';
export const CLINIC_LANDLINE = '+977-1-5538908';
